<img *ngIf="photoUrl" class="avatar-image" [src]="photoUrl" (error)="photoUrl = null"  [ngClass]="{'ua-medium': size === 'medium' , 'ua-small': size === 'small'}"/>
<div *ngIf="!photoUrl" class="avatar-image ua-name-user" [ngClass]="{'ua-medium': size === 'medium', 'ua-small': size === 'small' }">
  <div class="kenjo-font-size-35px">{{ nameInitials }}</div>
</div>
